import { standardLexicon } from '~/boggle/engine/standard/lexicon'
import { DexieBoggleLocalProgressStore } from './dexieProgressStore'
import { MemoryBoggleLocalProgressStore } from './memoryProgressStore'
import {
  DefaultBoggleProgressRepository,
  type BoggleProgressRepository,
} from './progressRepository'
import { BOGGLE_LEXICON_VERSION } from './types'

let singleton: BoggleProgressRepository | null = null

function canUseIndexedDb() {
  return typeof window !== 'undefined' && typeof window.indexedDB !== 'undefined'
}

export function getBoggleProgressRepository(): BoggleProgressRepository {
  singleton ??= new DefaultBoggleProgressRepository(
    canUseIndexedDb()
      ? new DexieBoggleLocalProgressStore()
      : new MemoryBoggleLocalProgressStore(),
    {
      isDictionaryWord: word => standardLexicon.isDictionaryWord(word),
      lexiconVersion: BOGGLE_LEXICON_VERSION,
    },
  )

  return singleton!
}
